<template>
    <div>
        <van-nav-bar
            :title="ticketType == 1?'优惠券':'兑换券'"
        />
        <div  class="stamp" v-bind:class="itemClass">
            <div v-if="ticketType == 1" class="par-money">
            <p class="p">{{item?item.shop_name:''}}</p>
            <span class="span">{{item?item.money:''}} 元</span>
            <br />
            <p class="p">满 {{item?item.full_money:''}} 可用</p>
            </div>
            <div v-if="ticketType == 2" class="par">
            <p class="p">{{item?item.shop_name:''}}</p>
            <span class="span">{{ item?item.title:''}}</span>
            </div>
            <div class="copy">
            <span>{{ item?item.title:'' }}</span>
            <div>
                <p>{{ item?item.begin_date:'' }}</p>
                <p>{{ item?item.end_date:'' }}</p>
            </div>
            </div>
            <i></i>
        </div>

        <van-cell v-if="userCouponStatus" title="您已领取了该券了哦"  />
        <van-cell v-if="!userCouponStatus &&isReceive" title="您来晚了，券已经被别人领跑了"  />
        <van-cell v-if="!share" title="点击右上角转赠给好友">
            <template #label>
                <p>转赠本张{{ticketType == 1?'优惠券':'兑换券'}}，注意转赠出去后，您将不能再使用本券"</p>
            </template>
        </van-cell>

        <van-button type="info" v-if="share && !userCouponStatus && !couponSourceUser && !isReceive" block plain hairline @click="receive()">领取</van-button>
    </div>
</template>

<script>
import { NavBar, Button, Cell } from 'vant';
import { CouponApi, VoucherApi, CouponTransferApi, VoucherTransferApi } from '@/api/vip'
import wxshare from "@/utils/wxshare"
import { getOpenId } from '@/utils/auth'
import { getCurDate } from '@/utils/dateutils'

export default {
    components: {
        [NavBar.name]: NavBar,
        [Button.name]: Button,
        [Cell.name]: Cell
    },
    data() {
        return {
            item: null,
            itemClass: null,
            //1:优惠券 2:兑换券
            ticketType: null,
            //是否从分享链接进入
            share: false,
            couponId: null,
            //当前用户微信openid
            userOpenId: null,
            // 分享用户微信openid
            shareUserOpenId:  null,
            //当前优惠券是否被领取
            isReceive: false,
            //当前优惠券是否起源于访问用户
            couponSourceUser: false,
            // 当前优惠券用户领取状态
            userCouponStatus: false
        }
    },
    mounted(){
        this.userOpenId = getOpenId()
        // 点击分享链接进入
        if(this.$route.query.coupon_type&&this.$route.query.id){
            this.share = true
            this.couponId = this.$route.query.id
            this.ticketType = this.$route.query.coupon_type
            this.shareUserOpenId = this.$route.query.share_user
        }
        // 用户点击我的券进入
        else{
            this.item = this.$route.query.item
            this.couponId = this.item.id
            this.ticketType = this.$route.query.type
            // this.overrideWeChatShare()
        }
        // 获取券样式，没有则随机生成一个样式
        this.itemClass = this.$route.query.itemClass?this.$route.query.itemClass:`stamp-${Math.round(3 * Math.random() + 1)}`
        this.getCoupon()
    },
    methods: {
        getCoupon() {   //获取优惠券或兑换券
            var that = this
            that.axios.get((this.ticketType ==1 ? CouponApi : VoucherApi)+that.couponId+'/').then((ret) => {
                console.log(ret)
                // this.item = ret;
                this.item={
                    id: ret.id,
                    shop_name: ret.shop_name,
                    title: ret.project_extra.name,
                    full_money: ret.full_money?ret.full_money:null,
                    money: ret.money,
                    begin_date: ret.begin_date,
                    end_date: ret.end_date,
                    project_id: ret.project_id,
                    project_type: ret.project_type,
                    status: ret.status
                }
                this.overrideWeChatShare();
                this.couponSourceUser = ret.initial_status?true:false;
                // 优惠券已领取过
                if (ret.transfer) {
                    this.isReceive = true;
                    // 当优惠券已被领取过，且分享用户为当前进入用户时，将可以被其他用户继续领取
                    if ( ret.transfer &&this.shareUserOpenId == ret.transfer.openid &&this.shareUserOpenId != this.userOpenId) {
                        this.isReceive = false;
                    }
                    if( this.userOpenId == ret.transfer.openid){
                        this.userCouponStatus =true
                    }else{
                        this.userCouponStatus =false
                    }
                }
            })
        },
        overrideWeChatShare(){
            // 重写微信分享链接
            // let obj={
            //     title:`赠送您一张${this.item.title}${ this.ticketType == 1 ? '优惠券' : '兑换券'}`,
            //     des:`汽车美容维修服务`,
            //     linkurl: `${window.location.origin}/#/nt/user/coupondetail?id=${this.item.id}&coupon_type=${this.ticketType}&share_user=${this.shareUserOpenId}`,//分享链接
            // }
            wxshare.shareItem(`赠送您一张${this.item.title}${ this.ticketType == 1 ? '优惠券' : '兑换券'}`,
                `汽车美容维修服务`,
                null,
                `${window.location.origin}/#/nt/user/coupondetail?id=${this.item.id}&coupon_type=${this.ticketType}&share_user=${this.shareUserOpenId}`)
            // wxshare.getJSSDK()
            // wxshare.overrideWXShare(obj)
        },
        receive(){
            let data = {
                openid: this.userOpenId,
                transfer_date: getCurDate()
            };
            // 更新
            var that = this
            if (this.item.transfer) {
                that.axios.put((that.ticketType ==1 ? CouponTransferApi : VoucherTransferApi) + that.item.transfer.id + '/',data).then((ret) => {
                    console.log(ret)
                    that.getCoupon()
                })
            }
            // 创建
            else {
                if (this.ticketType == 1) {
                    data['coupon_id'] = this.couponId;
                } else {
                    data['redemption_voucher_id'] = this.couponId;
                }
                that.axios.post((that.ticketType ==1 ? CouponTransferApi : VoucherTransferApi),data).then((ret) => {
                    console.log(ret)
                    that.getCoupon()
                })
            }
        }
    }
}
</script>

<style lang="less" scoped>
.stamp {
        width: 92%;
        height: 140px;
        padding: 0 0px;
        margin: 4%;
        position: relative;
        overflow: hidden;
        p {
            padding: 0;
            margin: 0;
        }
        &:before {
            content: '';
            position: absolute;
            top: 0;
            bottom: 0;
            left: 10px;
            right: 10px;
            z-index: -1;
        }
        i {
            position: absolute;
            left: 20%;
            top: 45px;
            height: 190px;
            width: 390px;
            background-color: rgba(255, 255, 255, 0.15);
            transform: rotate(-30deg);
            -ms-transform: rotate(-30deg);
            -moz-transform: rotate(-30deg);
            -webkit-transform: rotate(-30deg);
            -o-transform: rotate(-30deg);
        }
        .par {
            float: left;
            height: 100%;
            padding: 6% 15px;
            width: 51%;
            border-right: 2px dashed rgba(255, 255, 255, 0.3);
            text-align: left;
            .p {
                color: #fff;
                font-size: 16px;
                line-height: 21px;
                margin: 4px 0;
            }
            .span {
                font-size: 24px;
                color: #fff;
                margin-right: 5px;
                line-height: 30px;
            }
            button {
                position: absolute;
                bottom: 10%;
                left: 40%;
                z-index: 1;
            }
        }
        .copy {
            padding: 30px 0;
            vertical-align: text-bottom;
            font-size: 18px;
            color: rgb(255, 255, 255);
            text-align: center;
            line-height: initial;
            p:last-child {
                margin-top: 0px;
            }
            p {
                margin-top: 16px;
                font-size: 16px;
            }
        }
        .par-money {
            float: left;
            height: 100%;
            padding: 6% 15px;
            width: 61%;
            border-right: 2px dashed rgba(255, 255, 255, 0.3);
            text-align: left;
            .p {
                color: #fff;
                font-size: 16px;
                line-height: 21px;
                margin: 4px 0;
            }
            .span {
                font-size: 28px;
                color: #fff;
                margin-right: 5px;
                line-height: 34px;
            }
            button {
                position: absolute;
                bottom: 10%;
                left: 40%;
                z-index: 1;
            }
        }
    }
    .stamp-1 {
        background: radial-gradient(rgba(0, 0, 0, 0) 0, rgba(0, 0, 0, 0) 5px, #F39B00 5px);
        background-size: 15px 15px;
        background-position: 9px 3px;
        &:before {
            background-color: #F39B00;
        }
    }
    .stamp-2 {
        background: radial-gradient(rgba(0, 0, 0, 0) 0, rgba(0, 0, 0, 0) 5px, #D24161 5px);
        background-size: 15px 15px;
        background-position: 9px 3px;
        &:before {
            background-color: #D24161;
        }
    }
    .stamp-3 {
        background: radial-gradient(rgba(0, 0, 0, 0) 0, rgba(0, 0, 0, 0) 5px, #7EAB1E 5px);
        background-size: 15px 15px;
        background-position: 9px 3px;
        &:before {
            background-color: #7EAB1E;
        }
    }
    .stamp-4 {
        background: radial-gradient(rgba(0, 0, 0, 0) 0, rgba(0, 0, 0, 0) 5px, #50ADD3 5px);
        background-size: 15px 15px;
        background-position: 9px 3px;
        &:before {
            background-color: #50ADD3;
        }
    }
</style>